define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var ProfilesGridModel = {};

    function moduleDefinition (LEUserManagement, LE, Backbone, Marionette, $, _) {
        ProfilesGridModel = BaseModel.extend({
            defaults: {
                filters:{
                    "profileName": [],
                    "role": []
                },
                comparators:{
                    "profileName": "profileName",
                    "role": "role",
                    "description": "description",
                    "usersNum": "usersNum"
                }
            },
            name: "ProfileGridModel",
            pluck: function (model) {
                return true;
            },

            setFilterValue: function(filterName, filterValue){
                if(!_.isUndefined(this.get("filters." + filterName))){
                    this.set("filters." + filterName, filterValue);
                }
            },

            getFilterValue: function(filterName){
                return this.get("filters." + filterName);
            },

            predicate: function (model) {
                var modelIsInSelection = true;
                var passFilter;

                var privileges = {viewAll: LEUserManagement.hasAllProfilesViewPrivilege(), editAgentProfile: LEUserManagement.hasAgentProfileEditPrivilege(), editAgentManagerProfile: LEUserManagement.hasAgentManagerProfileEditPrivilege()};
                if (!privileges.viewAll) {
                    passFilter = model.isViewableForLoggedInUser(privileges);
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if model name is in selection:
                var nameFilter = this.get("filters.profileName");
                if(!_.isEmpty(nameFilter)) {
                    passFilter = _.some(nameFilter,function(name){
                        return model.getName() === name;
                    });

                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if model name is in selection:
                var roleFilter = this.get("filters.role");
                if(!_.isEmpty(roleFilter)) {
                    passFilter = _.some(roleFilter,function(id){
                        return model.getRoleTypeId() === id;
                    });

                    modelIsInSelection = modelIsInSelection && passFilter;
                }


                return modelIsInSelection;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfilesGridModel;
});
